import { render, staticRenderFns } from "./BbppProductServicesMP.vue?vue&type=template&id=5b1b829c"
import script from "./BbppProductServicesMP.vue?vue&type=script&lang=js"
export * from "./BbppProductServicesMP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports